import { useContext } from "react";
import TwgoldAuthContext from "../TWGLogin/TwgoldAuthContext";

export const useTwgoldAuth = () => {
  const context = useContext(TwgoldAuthContext);

  if (!context) {
    throw new Error("useTwgoldAuth must be used within TwgoldAuthProvider");
  }

  return context;
};